import { EVENT, EVENT_ACTION } from '@utils/tracking/constants'
import { getEventCategory } from '@utils/tracking/utils'
import { useCallback } from 'react'

import { useTrackingWrapper } from './use-tracking-wrapper'

export const useTrackOpenDialog = (label: string) => {
  const wrapper = useTrackingWrapper()

  return useCallback(() => {
    if (wrapper) {
      wrapper.triggerEvent(EVENT.PAGEVIEW, null, {
        categorie: getEventCategory(wrapper),
        action: EVENT_ACTION.AFFICHAGE_POPIN,
        label,
      })
    }
  }, [wrapper])
}
